import { constants, mediaQueryStyles } from "@newsela/angelou";

const { ui } = constants.colors;

const { mediaQuery: mq } = mediaQueryStyles;

const {
  BreakpointNames: { xs, md, lg },
} = constants.breakpoints;

const neutral700 = ui.neutral[700];

const coreBlue25 = ui.core[25];

export const challengesListCss = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  alignItems: "center",
  gap: "16px",
  width: "100%",
  justifyContent: "space-evenly",

  ">:nth-of-type(2)": {
    display: "none",
  },
  ">:nth-of-type(3)": {
    display: "none",
  },

  [mq.downTo(xs)]: {
    gridTemplateColumns: "repeat(2, 1fr)",
    ">:nth-of-type(2)": {
      display: "block",
    },

    ">:nth-of-type(3)": {
      display: "none",
    },
  },

  [mq.downTo(md)]: {
    gridTemplateColumns: "repeat(3, 1fr)",
    ">:nth-of-type(2)": {
      display: "block",
    },

    ">:nth-of-type(3)": {
      display: "block",
    },
    justifyContent: "left",
  },

  [mq.between(md, lg)]: {
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    height: "420px",
    overflowY: "hidden",
    ">:nth-of-type(4)": {
      display: "none",
    },
  },

  [mq.downTo(lg)]: {
    gridTemplateColumns: "repeat( auto-fit, minmax(250px, 1fr) )",
    height: "auto",
    ">:nth-of-type(4)": {
      display: "block",
    },
  },

  ".detailCard": {
    width: "100%",
    minWidth: "272px",
    borderRadius: "16px",
    backgroundColor: coreBlue25,
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
      cursor: "pointer",
      "-webkit-box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
      "-moz-box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
      "box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
    },
  },
};

export const challengesListSectionTitleCss = {
  margin: "0",
  color: neutral700,
  fontSize: "20px",
  lineHeight: "120%",
};
